var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus96075(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-96-075-1,.cls-96-075-2,.cls-96-075-3{fill:#fff;}.cls-96-075-2,.cls-96-075-4{stroke:#6e6e6e;}.cls-96-075-2,.cls-96-075-3,.cls-96-075-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-96-075-3{stroke:#ff6a10;}.cls-96-075-4,.cls-96-075-5{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "taustavalko"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-075-1",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96-075-2",
    points: "26.72 81.78 5.44 76.85 5.44 14.32 26.72 19.25 26.72 81.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96-075-2",
    points: "26.72 81.78 48 76.75 48 14.22 26.72 19.25 26.72 81.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96-075-2",
    points: "69.28 81.78 48 76.75 48 14.22 69.28 19.25 69.28 81.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96-075-2",
    points: "69.28 81.78 90.56 76.75 90.56 14.22 69.28 19.25 69.28 81.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-075-3",
    d: "M69.92,47.33c-4,3.15-4.32,4.49-4.32,6.59a2.78,2.78,0,0,1-3,2.79,2.85,2.85,0,0,1-3-3.08c0-3.44.7-5.6,4.72-8.81,3.15-2.56,5.13-4,5.13-7.11,0-4.2-3-5.77-6-5.77a8.06,8.06,0,0,0-5.83,2.22,3.06,3.06,0,0,1-4.66-2.34c0-1.4,1.22-2.56,2.39-3.32,2.33-1.51,4.89-2.27,8.8-2.27,5.48,0,12,3.09,12,10.84C76,42.08,73.24,44.65,69.92,47.33ZM62.57,69.77A4.43,4.43,0,1,1,67,65.34,4.43,4.43,0,0,1,62.57,69.77Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96-075-4",
    points: "5.44 57.08 26.72 39.73 47.74 40.86 53.6 44.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96-075-4",
    points: "14.71 49.52 26.12 63.42 48 59 52.9 57.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-96-075-4",
    points: "34.74 40.16 41.19 28.76 37.36 17.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96-075-4",
    d: "M90.56,65.34c0,.27-7.94,0-7.94,0l-8.43-7.62"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96-075-5",
    width: 96,
    height: 96
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus96075);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_96_075.8d5e5759da8e3d0768e3d864418207d7.svg";
export { ForwardRef as ReactComponent };